import { MessageLocal } from "app/api/types";
import { DateTime } from "luxon";

export const ADD_MESSAGE = 'ADD_MESSAGE';

export const addChatMessage = (message: {
	text: string,
	senderId: number,
	senderName: string,
	receiverId: number,
	time: string
}) => {
	return (dispatch: any): any => {
		const localMessage: MessageLocal = {
			text: message.text,
			time: DateTime.fromISO(message.time),
			senderId: message.senderId,
			senderName: message.senderName,
			receiverId: message.receiverId,
			receiverName: '',
			isIncoming: message.receiverId < 1
		}
		dispatch({ type: ADD_MESSAGE, localMessage });
	};
}
